import api from "./index";

/**
 * Buyer Management API
 * Handles buyer user operations in the admin panel
 */

// GET all buyers with pagination and search
export const getBuyers = (params = {}) =>
    api.get("role-management/buyers/", { params });

// GET single buyer by ID
export const getBuyerById = (id) =>
    api.get(`role-management/buyers/${id}/`);

// DELETE buyer by ID
export const deleteBuyer = (id) =>
    api.delete(`role-management/buyers/${id}/`);

// Toggle "Recently Purchased" on a buyer (CRM-2026-00054). Reversible.
export const setBuyerRecentlyPurchased = (id, value) =>
    api.patch(`role-management/buyers/${id}/`, { is_recently_purchased: !!value });

// Set (or clear, with null) the manually-entered date of purchase on a buyer,
// so the office knows roughly when to follow up next. Expects "YYYY-MM-DD".
export const setBuyerPurchaseDate = (id, date) =>
    api.patch(`role-management/buyers/${id}/`, { purchase_date: date || null });
